import { schemaCommon } from "common/bit/form/FormikSchema"
import * as yup from "yup"

const schemaTestDrive = yup
  .object({
    firstName: schemaCommon.firstName,
    lastName: schemaCommon.lastName,
    email: schemaCommon.email,
    phoneNumber: schemaCommon.phoneNumber,
    showRoom: yup.string().required("שדה חובה"),
    carModel: yup.string(),
  })
  .defined()

export const initialFormStatesTestDrive: yup.InferType<typeof schemaTestDrive> =
  {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    showRoom: "",
    carModel: "",
  }

export default schemaTestDrive
